import { TaskQueue } from './TaskQueue';
/**
 * Create deferred object.
 *
 * @returns {{promise, resolve, reject}}
 */
export function createDeferred() {
    const deferred = {};
    // @ts-ignore
    deferred.promise = new Promise((resolve, reject) => {
        // @ts-ignore
        deferred.resolve = resolve;
        // @ts-ignore
        deferred.reject = reject;
    });
    return deferred;
}
/**
 * Returns an instance of {@link TaskQueue}.
 *
 * @returns {Object}
 */
export function createTaskQueue() {
    return new TaskQueue();
}
